import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import JusticeEmblem from "@/components/JusticeEmblem";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const COLS = [
  { title: "Institute", links: [["/about", "About IOCRI"], ["/research", "Research"], ["/dashboard", "Intelligence"], ["/education", "Education"]] },
  { title: "Support", links: [["/victim-support", "Victim Support"], ["/awareness", "Awareness"], ["/ai-assistant", "AI Assistant"], ["/scam-detection", "Scam Detection"]] },
  { title: "Engage", links: [["/volunteer", "Volunteer"], ["/contact", "Contact"], ["#careers", "Careers"], ["/awareness", "Awareness"]] },
  { title: "Legal", links: [["#privacy", "Privacy Policy"], ["#terms", "Terms of Use"], ["#cookies", "Cookie Policy"], ["#accessibility", "Accessibility"]] },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("You are subscribed to the IOCRI briefing.");
      setEmail("");
    } catch {
      toast.error("Subscription failed. Please try again.");
    }
  };

  return (
    <footer className="mt-24 border-t border-white/5 bg-black" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="flex flex-col items-center text-center mb-14">
          <JusticeEmblem size="lg" />
          <h2 className="font-display text-4xl md:text-6xl mt-6 text-balance">
            <span className="text-white">Justice, </span>
            <span className="text-gold-gradient">Intelligence,</span>
            <span className="text-white"> and Human Dignity.</span>
          </h2>
          <p className="mt-4 text-white/60 max-w-2xl">
            Independent research and open education against organized crime — powered by artificial intelligence and global collaboration.
          </p>
          <form onSubmit={submit} className="mt-8 flex w-full max-w-md gap-2" data-testid="footer-newsletter-form">
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="footer-newsletter-input"
              placeholder="you@institute.org"
              className="bg-black border-white/10 rounded-full h-11 px-5 focus-visible:ring-gold text-white"
            />
            <Button type="submit" data-testid="footer-newsletter-submit" className="rounded-full bg-gold text-black hover:bg-gold-light">
              Subscribe
            </Button>
          </form>
        </div>

        <div className="divider-gold mb-14" />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {COLS.map((c) => (
            <div key={c.title}>
              <div className="text-gold font-mono text-xs tracking-[0.3em] mb-4">{c.title.toUpperCase()}</div>
              <ul className="space-y-2">
                {c.links.map(([to, label]) => (
                  <li key={label}>
                    <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-white/60 hover:text-gold text-sm">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="divider-gold my-12" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40 font-mono">
          <div>© {new Date().getFullYear()} International Organized Crime Research Institute — All Rights Reserved.</div>
          <div className="uppercase tracking-widest">EMERGENCY · 112 (EU) · 911 (US) · Local Police</div>
        </div>
      </div>
    </footer>
  );
}
